// extracted by mini-css-extract-plugin
module.exports = {"content":"AppLayout_content__1Fh4S","hasTickerNav":"AppLayout_hasTickerNav__1cfe6"};